<template>
  <button @click="$emit('click')" type="button" class="btn-card" :class="btnColor">
    <i class="fa" :class="faName"></i>
    <span class="btn-card__counter">{{ prefix }}{{ format !== null?format(counter):counter }}</span>
    <span>
      <slot></slot>
    </span>
  </button>
</template>
<script>
export default {
  props: {
    faName: {
      type: String,
      required: true
    },
    btnColor: {
      type: String,
      required: true
    },
    counter: {
      required: true
    },
    prefix: "",
    format: {
      required: false,
      default: function() {
        return null;
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/element/ButtonCard.vue